var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResultsCart = function SvgResultsCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M6.796 13.546c1.217 0 2.204.997 2.204 2.227S8.013 18 6.796 18a2.216 2.216 0 0 1-2.204-2.227c0-1.23.987-2.227 2.204-2.227zm7.347 0c1.217 0 2.204.997 2.204 2.227S15.36 18 14.143 18a2.216 2.216 0 0 1-2.204-2.227c0-1.23.986-2.227 2.204-2.227zm-7.347 1.485a.739.739 0 0 0-.735.742c0 .41.329.742.735.742a.739.739 0 0 0 .734-.742.739.739 0 0 0-.734-.742zm7.347 0a.739.739 0 0 0-.735.742c0 .41.329.742.735.742a.739.739 0 0 0 .734-.742.739.739 0 0 0-.734-.742zM2.573 0C3.77.002 4.78.9 4.937 2.098l.21 1.613h11.934c.58 0 1.015.536.9 1.11l-1.233 6.227c-.225 1.146-1.231 1.964-2.37 1.942H6.62a2.396 2.396 0 0 1-2.388-2.098L3.115 2.34a.553.553 0 0 0-.544-.484H.918A.923.923 0 0 1 0 .928C0 .415.411 0 .918 0zM15.96 5.567H5.39l.663 5.083a.555.555 0 0 0 .56.484h7.782a.553.553 0 0 0 .552-.45l1.014-5.117z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResultsCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/results-cart.d3d8e84b.svg";
export { ForwardRef as ReactComponent };